import { TaskStatusResponse } from '../services/api';
import { HtmlPreview } from './HtmlPreview';

interface TaskStatusProps {
  status: TaskStatusResponse | null;
  isLoading: boolean;
  error: string | null;
  taskId: string;
}

export function TaskStatus({ status, isLoading, error, taskId }: TaskStatusProps) {
  if (isLoading) {
    return (
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <div className="w-full bg-blue-200 rounded-full h-4 overflow-hidden">
          <div className="bg-blue-600 h-full w-1/3 animate-pulse"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-800">生成失败: {error}</p>
      </div>
    );
  }

  if (!status) {
    return null;
  }

  if (status.status === 'failed') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-800 font-medium">生成失败</p>
        {status.error && <p className="text-red-600 text-sm mt-1">{status.error}</p>}
      </div>
    );
  }

  if (status.status === 'processing' || status.status === 'queued') {
    return (
      <div>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="w-full bg-blue-200 rounded-full h-4 overflow-hidden">
            <div
              className="bg-blue-600 h-full transition-all duration-300"
              style={{ width: `${status.progress}%` }}
            ></div>
          </div>
          <p className="text-blue-700 text-sm mt-2">{Math.max(0, status.progress)}%</p>
        </div>
        {status.status === 'processing' && (
          <HtmlPreview taskId={taskId} progress={status.progress} />
        )}
      </div>
    );
  }

  if (status.status === 'completed') {
    return (
      <div>
        <div className="bg-green-50 border border-green-200 rounded-lg p-6">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-medium text-green-900">生成完成！</h3>
              {status.result && (
                <p className="text-green-700 text-sm mt-1">
                  文件大小: {(status.result.fileSize / 1024).toFixed(2)} KB
                </p>
              )}
            </div>
            <a
              href={`/api/tasks/${taskId}/download`}
              className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors"
              download
            >
              下载 PPT
            </a>
          </div>
        </div>
        <HtmlPreview taskId={taskId} progress={100} />
      </div>
    );
  }

  return null;
}
